import useLatestTransactionsStreamListener from '../components/hooks/useLatestTransactionsStreamListener';

const TransactionStreamListener = ({ projectIds, eventIds, tags }) => {
    useLatestTransactionsStreamListener(projectIds, eventIds, tags);
    return null;
};

export default TransactionStreamListener;
